import http from "../http-common";
/* eslint-disable */
class KomisariatService {
  komisariatList(page, itemPerPage, keyword, dpw, dpd) {
    return http.get(
      "/komisariat/list?page=" +
        page +
        "&item_per_page=" +
        itemPerPage +
        "&keyword=" +
        keyword +
        "&dpw_id=" +
        dpw +
        "&dpd_id=" +
        dpd,
      {
        headers: {
          "Content-type": "application/json",
          Authorization:
            "Bearer " + localStorage.getItem(process.env.VUE_APP_TOKEN_PREFIX),
        },
      },
    );
  }

  komisariatListAll() {
    return http.get("/komisariat/all", {
      headers: {
        "Content-type": "application/json",
        Authorization:
          "Bearer " + localStorage.getItem(process.env.VUE_APP_TOKEN_PREFIX),
      },
    });
  }

  komisariatListAllFilter(dpdId) {
    return http.get("/komisariat-dpd/all?dpd_id=" + dpdId, {
      headers: {
        "Content-type": "application/json",
        Authorization:
          "Bearer " + localStorage.getItem(process.env.VUE_APP_TOKEN_PREFIX),
      },
    });
  }

  create(data) {
    var bodyFormData = new FormData();
    bodyFormData.append("nama", data.nama);
    bodyFormData.append("alamat", data.alamat);

    if (data.selectedDpw && data.selectedDpw != undefined) {
      bodyFormData.append("dewan_pengurus_wilayah_id", data.selectedDpw.id);
    }

    if (data.selectedDpd && data.selectedDpd != undefined) {
      bodyFormData.append("dewan_pengurus_daerah_id", data.selectedDpd.id);
    }

    return http.post("/komisariat", bodyFormData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  }

  update(id, data) {
    var bodyFormData = new FormData();
    bodyFormData.append("id", id);
    bodyFormData.append("nama", data.nama);
    bodyFormData.append("alamat", data.alamat);

    if (data.selectedDpw && data.selectedDpw != undefined) {
      bodyFormData.append("dewan_pengurus_wilayah_id", data.selectedDpw.id);
    }

    if (data.selectedDpd && data.selectedDpd != undefined) {
      bodyFormData.append("dewan_pengurus_daerah_id", data.selectedDpd.id);
    }

    return http.put(`/komisariat/${id}`, bodyFormData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  }

  delete(id) {
    return http.delete(`/komisariat/${id}`, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  }
}

export default new KomisariatService();
